import { Card, CardContent } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ManageAccountLayout from '@views/ManageAccount/ManageAccountLayout';
import Deactivation from '@views/ManageAccount/Settings/Deactivation';

const messages = defineMessages({
  title: {
    id: 'manageAccount.settings',
    defaultMessage: 'Settings',
  },
});

export default function ManageSettingsPage(props: PagePropsWithBreadcrumbs) {
  const { formatMessage } = useIntl();

  return (
    <ManageAccountLayout
      friendlyName={formatMessage(messages.title)}
      pageProps={props}
    >
      {({ user_id }) => (
        <Card>
          <CardContent>
            <Deactivation id={user_id} />
          </CardContent>
        </Card>
      )}
    </ManageAccountLayout>
  );
}
